import { Button, Classes, Dialog, Intent } from '@blueprintjs/core'
import { lang } from 'botpress/shared'
import React, { FC } from 'react'
import './modern-settings.css'
//import privacyPolicyPdf from '../../public/mist-privacy-policy.pdf'

interface Props {
  isOpen: boolean
  toggle: () => void
}

const PrivacyAgreement: FC<Props> = ({ isOpen, toggle }) => {
  return (
    <Dialog
      title="Privacy Policy"
      icon="document"
      isOpen={isOpen}
      onClose={toggle}
      transitionDuration={0}
      canOutsideClickClose={false}
      className="modern-dialog"
      style={{ width: 750, maxHeight: '90vh' }}
    >
      <div className={Classes.DIALOG_BODY}>
        <div style={{ height: '65vh', overflow: 'hidden', padding: '0', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
          <object
            data={`${process.env.PUBLIC_URL || ''}/mist-privacy-policy.pdf#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0`}
            type="application/pdf"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          >
            <p style={{ padding: '24px', textAlign: 'center', color: '#64748b' }}>
              Your browser can't display the PDF inline.{' '}
              {/* <a href={privacyPolicyPdf} target="_blank" rel="noopener noreferrer">
                Open the Privacy Policy in a new tab
              </a> */}
              .
            </p>
          </object>
        </div>
      </div>

      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={toggle} className="modern-btn-primary">
            {lang.tr('close')}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default PrivacyAgreement
